import { globalStorage } from '../utils/storage/global-storage'
import ApplicationProperties, { defaultApplicationProperties } from './app-properties'

const PROPERTY_STORE_KEY = 'APP_PROPERTIES'
const CONFIG_ENV_KEY = 'CONFIG_ENV'

/**
 * global 저장소에서 property를 조회한다.
 */
export const getProperties = <T extends ApplicationProperties>(): T => {
  const prop = globalStorage.getItem(PROPERTY_STORE_KEY)

  if (!prop) {
    // console.warn('return default properties...')
    return defaultApplicationProperties as T
  } else {
    return prop as T
  }
}

/**
 * global 저장소에 property를 저장한다.
 */
export const setProperties = <T extends ApplicationProperties>(properties: T) => {
  globalStorage.setItem(PROPERTY_STORE_KEY, properties)
}

/**
 * global 저장소에 config env 정보를 저장한다.
 */
export const setConfigEnv = (configEnv: string) => {
  globalStorage.setItem(CONFIG_ENV_KEY, configEnv)
}

/**
 * global 저장소에서 config env 정보를 조회한다.
 */
export const getConfigEnv = () => {
  return globalStorage.getItem(CONFIG_ENV_KEY) || 'production'
}
